import { render, staticRenderFns } from "./ind-menu.vue?vue&type=template&id=2a2ef280&scoped=true&"
import script from "./ind-menu.vue?vue&type=script&lang=ts&"
export * from "./ind-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2ef280",
  null
  
)

export default component.exports